import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  checkoutLoading: false,
  paidPromotionsLoading: false,
  otherInstituteLoading: false,
  statusUpdateLoading: false,
  detailLoading: false,
  error: null,
  leadResult: null,
  checkoutResult: null,
  paypalOrder: null,
  paidSpecialPromotions: null,
  otherInstituteSpecialPromotions: null,
  pendingActivationDetail: null,
};

export const SpecialPromotionReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("SaveSpecialPromotionLeadRequest", (state) => {
      state.loading = true;
    })
    .addCase("SaveSpecialPromotionLeadSuccess", (state, action) => {
      state.loading = false;
      state.error = null;
      state.leadResult = action.payload;
    })
    .addCase("SaveSpecialPromotionLeadFailure", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    .addCase("CreateSpecialPromotionPayPalOrderRequest", (state) => {
      state.checkoutLoading = true;
    })
    .addCase("CreateSpecialPromotionPayPalOrderSuccess", (state, action) => {
      state.checkoutLoading = false;
      state.paypalOrder = action.payload;
      state.error = null;
    })
    .addCase("CreateSpecialPromotionPayPalOrderFailure", (state, action) => {
      state.checkoutLoading = false;
      state.error = action.payload;
    })

    .addCase("CompleteSpecialPromotionCheckoutRequest", (state) => {
      state.checkoutLoading = true;
      state.error = null;
    })
    .addCase("CompleteSpecialPromotionCheckoutSuccess", (state, action) => {
      state.checkoutLoading = false;
      state.checkoutResult = action.payload;
      state.error = null;
    })
    .addCase("CompleteSpecialPromotionCheckoutFailure", (state, action) => {
      state.checkoutLoading = false;
      state.error = action.payload;
    })

    .addCase("FetchPendingActivationDetailRequest", (state) => {
      state.detailLoading = true;
      state.error = null;
      state.pendingActivationDetail = null;
    })
    .addCase("FetchPendingActivationDetailSuccess", (state, action) => {
      state.detailLoading = false;
      state.pendingActivationDetail = action.payload;
    })
    .addCase("FetchPendingActivationDetailFailure", (state, action) => {
      state.detailLoading = false;
      state.error = action.payload;
    })

    .addCase("FetchPaidSpecialPromotionsRequest", (state) => {
      state.paidPromotionsLoading = true;
      state.error = null;
    })
    .addCase("FetchPaidSpecialPromotionsSuccess", (state, action) => {
      state.paidPromotionsLoading = false;
      state.paidSpecialPromotions = action.payload;
      state.error = null;
    })
    .addCase("FetchPaidSpecialPromotionsFailure", (state, action) => {
      state.paidPromotionsLoading = false;
      state.error = action.payload;
    })

    .addCase("FetchOtherInstituteSpecialPromotionsRequest", (state) => {
      state.otherInstituteLoading = true;
      state.error = null;
    })
    .addCase("FetchOtherInstituteSpecialPromotionsSuccess", (state, action) => {
      state.otherInstituteLoading = false;
      state.otherInstituteSpecialPromotions = action.payload;
      state.error = null;
    })
    .addCase("FetchOtherInstituteSpecialPromotionsFailure", (state, action) => {
      state.otherInstituteLoading = false;
      state.error = action.payload;
    })

    .addCase("UpdateOtherInstituteSpecialPromotionStatusRequest", (state) => {
      state.statusUpdateLoading = true;
      state.error = null;
    })
    .addCase("UpdateOtherInstituteSpecialPromotionStatusSuccess", (state) => {
      state.statusUpdateLoading = false;
      state.error = null;
    })
    .addCase("UpdateOtherInstituteSpecialPromotionStatusFailure", (state, action) => {
      state.statusUpdateLoading = false;
      state.error = action.payload;
    })

    .addCase("ResetSpecialPromotionCheckout", (state) => {
      state.checkoutLoading = false;
      state.checkoutResult = null;
      state.error = null;
    });
});
